import React, { ReactNode } from 'react'

import useNameFormatter from '@divvy-web/hooks.usenameformatter'
import { FormattedMessage } from '@divvy-web/i18n'
import AppHeader from '@divvy-web/skylab.appheader'
import BasicButton, { BASIC_BUTTON_TYPE_OUTLINED } from '@divvy-web/skylab.basicbutton'

import BillBrandLogo from '@sputnik/components/BillBrandLogo'

import SaveAndExitButton from './SaveAndExitButton'
import styles from './styles.module.scss'

interface CreditApplicationPageLayoutProps {
  pageTitle: ReactNode
  marketing: ReactNode
  hideBackButton?: boolean
  onBackClick?: () => void
  onNextClick?: () => void
  children: ReactNode
  nextButtonText?: ReactNode
  isNextButtonLoading?: boolean
  isNextButtonDisabled?: boolean
}
const CreditApplicationPageLayout = ({
  pageTitle,
  marketing,
  hideBackButton,
  onBackClick,
  onNextClick,
  children,
  nextButtonText,
  isNextButtonLoading = false,
  isNextButtonDisabled = false,
}: CreditApplicationPageLayoutProps) => {
  const [getClassName] = useNameFormatter('CreditApplicationPageLayout')

  return (
    <div className={`${styles[getClassName('')]} fs-unmask`}>
      <div className={styles[getClassName('form')]}>
        <div className={styles[getClassName('content-container')]}>
          <div className={styles[getClassName('logo')]}>
            <BillBrandLogo />
          </div>
          <AppHeader className={styles[getClassName('title')]}>
            <h1>{pageTitle}</h1>
          </AppHeader>
          <div className={styles[getClassName('content')]}>{children}</div>
        </div>
        <div className={styles[getClassName('footer')]}>
          <SaveAndExitButton />
          <div className={styles[getClassName('footer-navigation-buttons')]}>
            {!hideBackButton && (
              <BasicButton
                type={BASIC_BUTTON_TYPE_OUTLINED}
                onClick={onBackClick}
              >
                <FormattedMessage
                  defaultMessage='Back'
                  id='sputnik.CreditApplicationPageLayout__cyR7Kh'
                />
              </BasicButton>
            )}
            <BasicButton
              disabled={isNextButtonDisabled}
              showSpinner={isNextButtonLoading}
              onClick={onNextClick}
            >
              {nextButtonText ?? (
                <FormattedMessage
                  defaultMessage='Next'
                  id='sputnik.CreditApplicationPageLayout__9+Ddtu'
                />
              )}
            </BasicButton>
          </div>
        </div>
      </div>
      {marketing}
    </div>
  )
}

export default CreditApplicationPageLayout
